import * as yup from 'yup';

import { STRONG_EMAIL_REGEXP } from '@/utils/constants';

export const landlordFormSchema = yup
  .object({
    firstName: yup.string().trim().required('firstname-required'),
    lastName: yup.string().trim().required('lastname-required'),
    email: yup
      .string()
      .trim()
      .required('email-required')
      .email('email-invalid')
      .matches(STRONG_EMAIL_REGEXP, 'email-invalid'),
    company: yup.string().trim().required('company-required'),
    address: yup.string().trim().required('address-required'),
    comments: yup.string().trim(),
  })
  .required();

export type LandlordFormData = yup.InferType<typeof landlordFormSchema>;
